/**
 * Description: Factory for a characterProvider that loads character.json + resolves base URLs from a static root (CDN or /public/nanonomad-characters).
 * Usage: new NanoNomad({ runtimeConfig: { character: 'dog', characterProvider: createUrlCharacterProvider('https://cdn.example.com/nanonomad-characters/') } }).
 */
export function createUrlCharacterProvider(rootUrl) {
  const root = rootUrl.endsWith('/') ? rootUrl : rootUrl + '/';

  return {
    async getCharacter(id) {
      const slug = encodeURIComponent(id).replace(/%2F/g, '');
      const baseUrl = root + slug + '/';
      const configUrl = baseUrl + 'character.json';
      const res = await fetch(configUrl);
      if (!res.ok) {
        throw new Error('NanoNomad: character not found: ' + id);
      }
      const config = await res.json();
      return {
        config,
        baseUrl,
        configUrl,
      };
    },
  };
}
